import React, { useState } from "react";
import HelloText from "../components/HelloText";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
const MenuCategoryAdd = () => {
  const [name, setName] = useState();
  return (
    <>
      <HelloText />
      <Box
        component="form"
        method="post"
        action={process.env.REACT_APP_DEF_URL + "menuadd"}
        sx={{
          "& > :not(style)": {
            m: 1,
            width: "80%",
            display: "flex",
            alignItems: "center",
          },
        }}
        noValidate
        autoComplete="off"
      >
        <TextField
          id="outlined-basics"
          label="Başlık"
          variant={"outlined"}
          fullWidth
          name="head_name"
          onChange={(e) => setName(e.target.value)}
          value={name}
        />
        {name ? (
          <Button variant="outlined" type="submit">
            Ekle
          </Button>
        ) : (
          <Button variant="outlined" disabled type="button">
            Ekle
          </Button>
        )}
      </Box>
    </>
  );
};

export default MenuCategoryAdd;
